import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { selectIsAuthenticated } from '../store/selectors';
import { BYPASS_AUTH } from '../utils/ip';

const PublicRoute = ({ children }) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const hasToken = !!localStorage.getItem('accessToken');
  const bypassAuth = BYPASS_AUTH === 'true';

  if (bypassAuth) {
    return children;
  }

  if (isAuthenticated || hasToken) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;
